import { render } from "./DiscountModal.vue?vue&type=template&id=bb25025a&scoped=true"
import script from "./DiscountModal.vue?vue&type=script&lang=js"
export * from "./DiscountModal.vue?vue&type=script&lang=js"

import "./DiscountModal.vue?vue&type=style&index=0&id=bb25025a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb25025a"]])

export default __exports__